import { BaseService } from '../../services';
import { GrafanaLoggerLog } from '../entities';

export class GrafanaLoggerService extends BaseService {
  async pushLogs(logs: Array<GrafanaLoggerLog>) {
    return this.httpClient.post('/', { data: logs });
  }
}
